import React from "react";
import "./TabelauBNC.css";

function TabelauBNC({
  formData,
  handleCheckboxChangeTabeleau,
  handleCheckboxChangeDevis,
}) {
  return (
    <div className="Annexe2">
      {" "}
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th
              style={{
                padding: "8px",
                textAlign: "left",
              }}
            >
              NATURE DES OBLIGATIONS RESPECTIVES
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Client
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Cabinet
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Devis
            </th>
          </tr>
        </thead>
        <tbody>
          <p style={{ fontWeight: "bold", margin: "0", paddingTop: "10px" }}>
            1/ INTERVENTION COMPTABLE
          </p>
          <p
            style={{
              fontWeight: "lighter",
              margin: "0",
              paddingTop: "5px",
              paddingBottom: "8px",
            }}
          >
            Entreprise individuelle
          </p>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Brouillard de recettes
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="bdrcl"
                checked={formData.bdrcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}></td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="bdro"
                checked={formData.bdro === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Journaux de Banque
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jdbcl"
                checked={formData.jdbcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jdbca"
                checked={formData.jdbca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jdbo"
                checked={formData.jdbo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Journaux de Caisse
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jdccl"
                checked={formData.jdccl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jdcca"
                checked={formData.jdcca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jdco"
                checked={formData.jdco === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Journaux d'opérations diverses
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jddcl"
                checked={formData.jddcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jddca"
                checked={formData.jddca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="jddo"
                checked={formData.jddo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Contrôle des pièces justificatives
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdpjcl"
                checked={formData.cdpjcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdpjca"
                checked={formData.cdpjca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdpjo"
                checked={formData.cdpjo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Rapprochement bancaire
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rbcl"
                checked={formData.rbcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rbca"
                checked={formData.rbca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rbo"
                checked={formData.rbo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Centralisation journaux
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cjcl"
                checked={formData.cjcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cjca"
                checked={formData.cjca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cjo"
                checked={formData.cjo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Balances
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="bcl"
                checked={formData.bcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="bca"
                checked={formData.bca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="bo"
                checked={formData.bo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Grand livre
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="glcl"
                checked={formData.glcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="glca"
                checked={formData.glca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="glo"
                checked={formData.glo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Etats comparatifs de fin d'exercice
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ecdfdcl"
                checked={formData.ecdfdcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ecdfdca"
                checked={formData.ecdfdca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ecdfdo"
                checked={formData.ecdfdo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Registre des immobilisations
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdicl"
                checked={formData.rdicl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdica"
                checked={formData.rdica === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdio"
                checked={formData.rdio === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Classement des pièces justificatives
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdpjucl"
                checked={formData.cdpjucl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdpjuca"
                checked={formData.cdpjuca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdpjuo"
                checked={formData.cdpjuo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Contrôle des imputations
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdicl"
                checked={formData.cdicl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdica"
                checked={formData.cdica === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="cdio"
                checked={formData.cdio === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <br />
          <p style={{ fontWeight: "bold", margin: "0", paddingTop: "10px" }}>
            2/ AUTRES INTERVENTIONS
          </p>
          <p
            style={{
              fontWeight: "lighter",
              margin: "0",
              paddingTop: "5px",
              paddingBottom: "8px",
            }}
          >
            Interventions en matière fiscale
          </p>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclaration fiscale 2035
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="df2cl"
                checked={formData.df2cl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="df2ca"
                checked={formData.df2ca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="df2o"
                checked={formData.df2o === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclaration de chiffre d'affaires
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddcdcl"
                checked={formData.ddcdcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddcdca"
                checked={formData.ddcdca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddcdo"
                checked={formData.ddcdo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclaration européenne de services
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dedscl"
                checked={formData.dedscl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dedsca"
                checked={formData.dedsca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dedso"
                checked={formData.dedso === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclaration des honoraires
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddhcl"
                checked={formData.ddhcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddhca"
                checked={formData.ddhca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddho"
                checked={formData.ddho === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclarations fiscales diverses (A préciser)
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dfdapcl"
                checked={formData.dfdapcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dfdapca"
                checked={formData.dfdapca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dfdapo"
                checked={formData.dfdapo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Documents de l'association agréée
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddlaacl"
                checked={formData.ddlaacl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddlaaca"
                checked={formData.ddlaaca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="ddlaao"
                checked={formData.ddlaao === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Assistance en cas de vérification fiscale
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aecdvfcl"
                checked={formData.aecdvfcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aecdvfca"
                checked={formData.aecdvfca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aecdvfo"
                checked={formData.aecdvfo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <br />
          <p
            style={{
              fontWeight: "lighter",
              margin: "0",
              paddingTop: "5px",
              paddingBottom: "8px",
            }}
          >
            Interventions en matière de législation sociale
          </p>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Bulletins de paie
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="bdpcl"
                checked={formData.bdpcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="bdpca"
                checked={formData.bdpca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="bdpo"
                checked={formData.bdpo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclarations mensuelles ou trimestrielles aux organismes sociaux
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dmotaoscl"
                checked={formData.dmotaoscl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dmotaosca"
                checked={formData.dmotaosca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dmotaoso"
                checked={formData.dmotaoso === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Registres obligatoires (livre de paie, registre unique du
              personnel)
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rocl"
                checked={formData.rocl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="roca"
                checked={formData.roca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="roo"
                checked={formData.roo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclarations annuelles des salaires aux organismes sociaux
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dadsaoscl"
                checked={formData.dadsaoscl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dadsaosca"
                checked={formData.dadsaosca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dadsaoso"
                checked={formData.dadsaoso === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclarations aux organismes sociaux (non salariés)
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="daoscl"
                checked={formData.daoscl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="daosca"
                checked={formData.daosca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="daoso"
                checked={formData.daoso === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Assistance aux contrôles effectués par les différents organismes
              sociaux
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aacepldoscl"
                checked={formData.aacepldoscl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aacepldosca"
                checked={formData.aacepldosca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="aacepldoso"
                checked={formData.aacepldoso === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <br />
          <p
            style={{
              fontWeight: "lighter",
              margin: "0",
              paddingTop: "5px",
              paddingBottom: "8px",
            }}
          >
            Interventions en matière de gestion
          </p>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Dossier de gestion
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dgcl"
                checked={formData.dgcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dgca"
                checked={formData.dgca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dgo"
                checked={formData.dgo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Tableau de bord
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdbcl"
                checked={formData.tdbcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdbca"
                checked={formData.tdbca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="tdbo"
                checked={formData.tdbo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Budget
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="bucl"
                checked={formData.bucl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="buca"
                checked={formData.buca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="buo"
                checked={formData.buo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Diagnostic patrimonial
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dpcl"
                checked={formData.dpcl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dpca"
                checked={formData.dpca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="dpo"
                checked={formData.dpo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <br />
          <p
            style={{
              fontWeight: "lighter",
              margin: "0",
              paddingTop: "5px",
              paddingBottom: "8px",
            }}
          >
            Interventions en matière juridique (société) – Non applicable
          </p>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Formalités de convocation des AGO
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="fdcdacl"
                checked={formData.fdcdacl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="fdcdaca"
                checked={formData.fdcdaca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="fdcdao"
                checked={formData.fdcdao === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Procès-verbal de l'AGO
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pvdacl"
                checked={formData.pvdacl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pvdaca"
                checked={formData.pvdaca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="pvdao"
                checked={formData.pvdao === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Rapport de gestion à l'AGO
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdgaacl"
                checked={formData.rdgaacl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdgaaca"
                checked={formData.rdgaaca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="rdgaao"
                checked={formData.rdgaao === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Formalités de publicité annuelle
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="fdpacl"
                checked={formData.fdpacl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="fdpaca"
                checked={formData.fdpaca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="fdpao"
                checked={formData.fdpao === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Mise à jour des registres obligatoires
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="majdrocl"
                checked={formData.majdrocl === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="majdroca"
                checked={formData.majdroca === "X"}
                onChange={handleCheckboxChangeTabeleau}
              />
            </td>
            <td style={{ border: "1px solid black", textAlign: "center" }}>
              <input
                type="checkbox"
                name="majdroo"
                checked={formData.majdroo === "Sur devis"}
                onChange={handleCheckboxChangeDevis}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default TabelauBNC;
